import { render, staticRenderFns } from "./shippingMethod.vue?vue&type=template&id=a28da6bc&scoped=true"
import script from "./shippingMethod.vue?vue&type=script&lang=js"
export * from "./shippingMethod.vue?vue&type=script&lang=js"
import style0 from "./shippingMethod.vue?vue&type=style&index=0&id=a28da6bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28da6bc",
  null
  
)

export default component.exports